import React from "react";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import DocsHelper from "util/DocsHelper";
import DataLakeRetrievalsList from "./DataLakeRetrievalsList";
import DataLakeJobs from "../components/DataLakeJobs";
const DataLakeRetrievalsPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Data Lake Retrievals" }, /* @__PURE__ */ React.createElement(
  PageHeader,
  {
    title: "Data Lake Retrievals",
    documentationLink: {
      title: "Data Lake documentation",
      path: DocsHelper.PAGES.DATA_LAKE
    }
  },
  /* @__PURE__ */ React.createElement("span", null, "Retrieval Operations from Data Lakes can be viewed on this page. This includes both Graylog's internal Data Lake, and External Data lakes such as Amazon Security Lake.")
), /* @__PURE__ */ React.createElement(DataLakeJobs, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeRetrievalsList, null))));
export default DataLakeRetrievalsPage;
